import Audiologist3year64 from '@evocolabs/icons/lib/Audiologist3year64'
import I45days64 from '@evocolabs/icons/lib/I45days64'
import ShippingFree64 from '@evocolabs/icons/lib/ShippingFree64'

const productImgs = [
  'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/orka2-6.jpg',
  'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/orka2-0.jpg',
  'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/orka2-1.png',
  'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/orka2-2.png',
  'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/orka2-3.jpg',
  // 'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/orka2-4.jpg',
  'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/orka2-5.jpg',
  'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/orka2-7.png',
]

const miniProductImgs = [
  'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/orka2-6.jpg',
  'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/orka2-m0.png',
  'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/orka2-m1.png',
  'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/orka2-m2.png',
  'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/orka2-m3.png',
  // 'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/orka2-m4.png',
  'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/orka2-m5.png',
  'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/orka2-m7.png',
  'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/orka2-m6.png',
]

const whatBoxImgs = [
  'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/Fixed-aspect-ratio-spacer.jpg'
]

const techSpecsImgs = [
  'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/hearing-aids-info.png',
  'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/charging-case-info.png'
]

const serviceImgs = [
  'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/Unlimited_Remote_Care.jpg',
  'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/Welcome_Call.png',
  'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/Orka_Health_App.png',
  'https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/Complimentary_in_App_Hearing_Test.png'
]

const warrantyImgs = [Audiologist3year64, I45days64, ShippingFree64]

export default {
  productImgs,
  miniProductImgs,
  whatBoxImgs,
  techSpecsImgs,
  serviceImgs,
  warrantyImgs
}
